const translations = {
    buttonText: 'Confirm location',
    mapPinInfoWindowBodyText: 'Pinned Location:'
};

export default translations;
